import { css } from '@emotion/css';
import { useTheme } from '@mui/material/styles';
import ShowMoreText from 'react-show-more-text';
import React, { useMemo } from 'react';
import { I18n } from 'utils/i18n';

const MyShowMoreText = props => {
  const theme = useTheme();
  const anchorClass = useMemo(
    () => css({ color: theme.palette.primary.main }),
    [theme.palette.primary.main],
  );
  const newProps = {
    lines: 2,
    anchorClass,
    more: I18n.t('Show more'),
    less: I18n.t('Show less'),
    ...props,
  };
  return <ShowMoreText {...newProps} />;
};

export default MyShowMoreText;
